(function () {
  function closeDrawers() {
    document.querySelectorAll('.sv-header__drawer.is-open').forEach(function (drawer) {
      drawer.classList.remove('is-open');
    });
    document.querySelectorAll('[data-sv-header-backdrop]').forEach(function (backdrop) {
      backdrop.classList.remove('is-open');
    });
    document.querySelectorAll('[data-sv-header-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('sv-header-drawer-open');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sv-header-toggle]');
    if (toggle) {
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      var isOpen = drawer.classList.toggle('is-open');
      document.querySelectorAll('[data-sv-header-backdrop]').forEach(function (backdrop) {
        backdrop.classList.toggle('is-open', isOpen);
      });
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('sv-header-drawer-open', isOpen);
      return;
    }

    if (event.target.closest('[data-sv-header-close]') || event.target.closest('[data-sv-header-backdrop]')) {
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawers();
    }
  });
})();
